import { SubscriptionFeature } from "../../../types/billing/SubscriptionFeature";

export const resourcesFeatures: SubscriptionFeature[] = [
    SubscriptionFeature.CloMarketTrands,
    SubscriptionFeature.HistoricalWebinars
];
